import React from "react";
import "../App.css";

const How = () => {
  return (
    <div className="how" id="how-s">
      <div className="title-d">
        <i>T-Textual<br></br>H-Hub for<br></br>O-Organized<br></br>T-Talking and<br></br>T-Texting<br></br>I-Instant Messaging.</i>
      </div>
      <br></br>
      <div className="desc1" align="justify">
        Thotti is a revolutionary chatting application designed to elevate your
        communication experience like never before. With Thotti, you can
        effortlessly create personalized chat rooms and set unique pins,
        enabling a secure and private environment for your conversations.
        Immerse yourself in a world of seamless communication, where you can
        effortlessly connect with friends, family, colleagues, or even new
        acquaintances. Share your thoughts, ideas, and emotions without any
        inhibitions, knowing that Thotti preserves your privacy with top-notch
        security features. Express your creativity within the chat rooms, as
        Thotti provides an array of customizable features, including background
        splines, themes, and font styles. Be it casual conversations, serious
        discussions, or fun-filled banter, Thotti accommodates all your needs
        with ease. Stay organized with message timestamps and effortlessly
        scroll through the chat history. Discover the joy of real-time
        communication, where messages appear instantly, fostering a sense of
        togetherness and spontaneity. Thotti embraces innovation with its
        user-friendly interface, intuitive design, and compatibility across
        various devices, making it your go-to chatting companion wherever you
        go. Experience the power of connection with Thotti – your gateway to
        meaningful interactions, limitless creativity, and boundless
        communication possibilities. Join us on this exciting journey, and
        together, let's explore the world of communication without limits.
      </div>
    </div>
  );
};

export default How;
